<template>
  <img :src="getPlaceHolder()" :data-src="getPoster(content)" class="contentPoster" alt="" :style="[{ 'border-radius': `${borderRadius}` }]" @error="actLoadError" data-lazy-load :key="content.id+ '?t=' + new Date().getTime()"/>    
</template>
  
<script>
  import { observerInterSection } from "@/modules/observerInterSection";
  
  export default {
    name: "ImageTemplate",
    props: {
        content: {
            type: Object,
        },
        borderRadius: {
          type: String,
          default: "0px"
        },
        displayType: {
          type: String
        }
    },
    data() {
      return {
        gotPosterItem: null,
        placeholder_port: require('@/assets/placeholder-port.svg'),
        placeholder_lands: require('@/assets/placeholder-lands.svg'),
        placeholder_sqare: require('@/assets/placeholder-square.svg'),
      }
    },
    mounted() {
        // this.getPoster(this.content);
        observerInterSection();
    },
    methods: {
      actLoadError (e) {
        e.target.src = this.placeholder_lands;
      },
      // getPoster(content) {
      //   console.log("oooo", content, this.displayType?.toLowerCase(), content?.poster?.[this.displayType?.toLowerCase()])
      //   if(content?.poster?.[this.displayType?.toLowerCase()]) {
      //     this.gotPosterItem = content[this.displayType.toLowerCase()];
      //     return this.gotPosterItem;
      //   }
      //   const filterData = content?.poster?.filter((item) => {
      //     if (this.displayType && item.postertype === this.displayType) return item;
      //   });

      //   if (filterData?.length > 0 ) {
      //     const finalImg = [];
      //     let alterFileList  = filterData[0]?.filelist;          
      //     for (let el of alterFileList) {
      //       if (el.quality === "SD") {
      //         this.gotPosterItem = el.filename;
      //         break;
      //       } else if (el.quality === "HD") {
      //         this.gotPosterItem = el.filename;
      //         break;
      //       } else {
      //         if(this.displayType === 'LANDSCAPE') {
      //           this.gotPosterItem = this.placeholder_lands;
      //         } else if(this.displayType === 'PORTRAIT'){
      //           this.gotPosterItem = this.placeholder_port;
      //         } else if(this.displayType === 'SQUARE'){
      //           this.gotPosterItem = this.placeholder_sqare;
      //         }

      //         break;
      //       }
      //     }
      //     // this.gotPosterItem = this.gotPosterItem ? this.gotPosterItem : this.placeholder_lands;
      //   } else if(content.thumbnail){
      //     this.gotPosterItem = content.thumbnail;
      //   } else {
      //     if(this.displayType === 'LANDSCAPE') {
      //       this.gotPosterItem = this.placeholder_lands;
      //     } else if(this.displayType === 'PORTRAIT'){
      //       this.gotPosterItem = this.placeholder_port;
      //     } else if(this.displayType === 'SQUARE'){
      //       this.gotPosterItem = this.placeholder_sqare;
      //     }
      //   }
      //   return this.gotPosterItem;
        
      // },
      getPoster(content) {
        const typeKey = this.displayType?.toLowerCase();
        let posterUrl = null;
        // console.log('content.poster?.[typeKey]', content.poster?.[typeKey]);
        // Case 1: poster is an object (portrait/landscape/square keys)
        if (content?.poster && !Array.isArray(content.poster)) {
          const val = content.poster?.[typeKey];
          if (val && val.trim() !== "") {
            posterUrl = val;
          }
        }

        // Case 2: poster is an array of objects
        if (!posterUrl && Array.isArray(content?.poster)) {
          const matchType = content.poster.find(item => 
            item?.postertype?.toLowerCase() === typeKey
          );

          if (matchType?.filelist?.length) {
            const preferred = matchType.filelist.find(el => el.quality === "SD") 
                          || matchType.filelist.find(el => el.quality === "HD");
            posterUrl = preferred?.filename || null;
          }
        }

        // Case 3: fallback to thumbnail
        if (!posterUrl && content?.thumbnail) {
          posterUrl = content.thumbnail;
        }

        // Case 4: final placeholder fallback
        if (!posterUrl) {
          if (this.displayType === 'LANDSCAPE') {
            posterUrl = this.placeholder_lands;
          } else if (this.displayType === 'PORTRAIT') {
            posterUrl = this.placeholder_port;
          } else if (this.displayType === 'SQUARE') {
            posterUrl = this.placeholder_sqare;
          }
        }

        this.gotPosterItem = posterUrl;
        return posterUrl;
      },

      getPlaceHolder() {
        if(this.displayType === 'LANDSCAPE') {
          return this.placeholder_lands;
        } else if(this.displayType === 'PORTRAIT'){
          return this.placeholder_port;
        } else if(this.displayType === 'SQUARE'){
          return this.placeholder_sqare;
        }
      }
    },

    components: {     
      PlayButton: () => import(/* webpackChunkName: "playButton" */ "@/components/buttons/play.vue"),
    },
  }
</script>
  
